import { FlyerTemplate } from "../types/flyer-template/flyer-template.interface";
import { Canvas } from "../types/canvas/canvas.interface";
import { useEffect, useState } from "react";
import { createCanvas } from "../types/canvas/canvas.functions";
import { getWindowHeight, getWindowWidth } from "../../../../../types/dom/dom.functions";
import { Nullable } from "../../../../../types/common";

const doCreateCanvas = (template: Nullable<FlyerTemplate>) =>
  createCanvas(getWindowWidth(), getWindowHeight(), template?.aspectRatio || 1);

export function useFlyerTemplateCanvas(template: Nullable<FlyerTemplate>): Canvas {
  const [canvas, setCanvas] = useState<Nullable<Canvas>>(null);

  useEffect(() => {
    const handleResize = () => setCanvas(doCreateCanvas(template));
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [template, setCanvas]);

  useEffect(() => {
    setCanvas(doCreateCanvas(template));
  }, [template, setCanvas]);

  return canvas || doCreateCanvas(template);
}
